export default () => {
    return {
        mounted(shift = 25, reverse = false, scope = null) {
            if (scope === 'lg') {
                ScrollTrigger.matchMedia({
                    '(min-width: 1024px)': () => {
                        this.parallax(shift, reverse);
                    }
                });
            } else if (scope === 'md') {
                ScrollTrigger.matchMedia({
                    '(min-width: 768px)': () => {
                        this.parallax(shift, reverse);
                    }
                });
            } else if (scope === 'sm') {
                ScrollTrigger.matchMedia({
                    '(min-width: 640px)': () => {
                        this.parallax(shift, reverse);
                    }
                });
            } else {
                this.parallax(shift, reverse);
            }
        },

        parallax(shift, reverse) {
            const start = reverse ? -shift : shift;
            const end = reverse ? shift : -shift;

            gsap.fromTo(
                this.$refs.element,
                { yPercent: start },
                { yPercent: end, ease: 'none', scrollTrigger: { trigger: this.$refs.container, scrub: true } }
            );
        }
    };
};
